import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import HarbourIconButton from '../../components/harbour/HarbourIconButton';
import './family.css';

/*
 * Family portal crisis line. Agreed crisis wording for parents and carers
 * (Jasmine, 3 Oct 2026); the lead takes the child's name. The 999 sentence
 * stays on the page; the mental health contacts open from the "Urgent mental
 * health advice" link in a dialog, word for word (design update 5 Oct 2026).
 * The contact details are the Blackpool service's real numbers, as designed.
 */
export default function FamilyCrisisLine({ childName, className = '', callButton = true }) {
  return (
    <section className={`family-crisis ${className}`.trim()} aria-label="If you need urgent help">
      <div className="family-crisis__body">
        <h2 className="family-crisis__heading">
          {`If you’re worried about ${childName || 'your child'}’s safety right now.`}
        </h2>
        <p className="family-crisis__lead">
          If you think {childName || 'your child'} is in immediate danger, needs urgent medical
          help, or may hurt themselves or someone else, call 999 or take them to
          Blackpool Victoria Hospital A&amp;E.
        </p>
      </div>
      {/* Phone only (TDI-826 part 3): a parent reading this on the device
          that makes the call gets the call as a button. It adds no advice —
          the label repeats what the paragraph already says (R-011's wording
          is untouched) — and the laptop layout hides it (family.css). */}
      {callButton && (
        <a href="tel:999" className="harbour-btn harbour-btn--secondary family-crisis__call-999">
          Call 999
        </a>
      )}
      <Dialog.Root>
        <Dialog.Trigger asChild>
          <button type="button" className="family-crisis__advice-link">
            More places to get urgent mental health help
          </button>
        </Dialog.Trigger>
        <Dialog.Portal>
          <Dialog.Overlay className="harbour harbour-scrim" />
          <Dialog.Content className="harbour family-urgent-help-dialog" aria-describedby={undefined}>
            <div className="family-urgent-help-dialog__header">
              <Dialog.Title asChild>
                <h1 className="family-urgent-help-dialog__title" tabIndex={-1}>
                  Urgent mental health advice
                </h1>
              </Dialog.Title>
              <Dialog.Close asChild>
                <HarbourIconButton kind="ghost" icon="close" label="Close urgent mental health advice" />
              </Dialog.Close>
            </div>
            <p>
              For urgent mental health advice, you can also contact the Initial
              Response Service (IRS) on <a href="tel:08000130708">0800 013 0708</a> (24/7).
            </p>
            <p>For urgent mental health concerns, you can contact:</p>
            <ul>
              <li>
                CAMHS on <a href="tel:08001217762">0800 121 7762</a>, option 1 during
                working hours (Monday-Friday, 9am-5pm)
              </li>
              <li>
                Blackpool RAIS on <a href="tel:08001217762">0800 121 7762</a>, option 2
                (evenings 5-10pm and weekends 10am-10pm)
              </li>
              <li>
                NHS <a href="tel:111">111</a> and select the mental health option.
              </li>
            </ul>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </section>
  );
}
